import { isNil, cloneDeep } from 'lodash';
// Import Constants
import {
    CJArgumentValuesTypes,
    CJReferenceInArgumentType,
    CJFormulaInArgumentType,
    defaultLogicFunction,
} from 'constants/common';

const { StaticInArgument, ReferenceInArgument, DynamicDateInArgument } = CJArgumentValuesTypes;

export const optionValueBuilder = (argumentInType: Nilable<string> = undefined, data: AnyObject = {}) => {
    switch (argumentInType) {
        case StaticInArgument: {
            const { value } = data;

            return value;
        }
        case ReferenceInArgument: {
            const { blockId, name, logicFunction } = data;
            if (!isNil(logicFunction) && logicFunction !== defaultLogicFunction) {
                return {
                    $type: CJFormulaInArgumentType,
                    Name: logicFunction,
                    Arguments: [
                        {
                            $type: CJReferenceInArgumentType,
                            Block: blockId,
                            Property: name,
                        },
                    ],
                };
            }
            return {
                $type: CJReferenceInArgumentType,
                Block: blockId,
                Property: name,
            };
        }

        case DynamicDateInArgument: {
            const { value } = data;
            const { DateOffset, Manipulations } = value;

            return {
                Manipulations,
                DateOffset,
            };
        }
        default:
            // DefaultInArgument
            return {};
    }
};

// TODO: mapping from angular
export const detectTemplate = ({ LeftValue: left, RightValue: right }) => {
    const rm = cloneDeep(right.Manipulations);
    const lm = cloneDeep(left.Manipulations);

    // TODO: migration for old cj's need to change logic
    if (!isNil(lm) && lm.length > 0 && lm[0].Method === 'add' && lm[0].Params[1] === 'minutes') {
        lm.shift();
    }
    if (!isNil(rm) && rm.length > 0 && rm[0].Method === 'add' && rm[0].Params[1] === 'minutes') {
        rm.shift();
    }
    if (lm && lm.length) {
        // has left manipulations
        if (!right.DateOffset) {
            switch (rm.length) {
                case 4:
                    return 'thisDayOfYear';
                case 3:
                    return 'yesterday';
                default:
                    return 'today';
            }
        }
        return rm.length === 3 ? 'daysLater' : 'sameDay';
    } else {
        if (rm[0].Method === 'add') {
            return 'lastDayOfMonth';
        }
        if (rm[0].Method === 'days') {
            return 'weekday';
        }
        if (rm[0].Method === 'dates') {
            switch (rm.length) {
                case 1:
                    return 'dayOfMonth';
                case 2:
                    return 'dayOfYear';
                case 3:
                    return 'date';
                case 5:
                    return 'dateTime';
                default:
                    break;
            }
        }
        return 'time';
    }
};
